import React, { Children, cloneElement, useCallback, useRef } from 'react';
import { findDOMNode } from 'react-dom';
import noop from 'lodash/noop';
import Tooltip from '../tooltip/Tooltip';
import utilIsOverflow from './util';
function renderTitle(props) {
    if (props) {
        const { trigger } = props;
        if (trigger) {
            return Children.map(trigger, (item) => cloneElement(item, { ref: null, className: null }));
        }
    }
}
const OverflowTip = (props) => {
    const ref = useRef(null);
    const defaultGetOverflowContainer = useCallback(() => {
        const { current } = ref;
        if (current) {
            return findDOMNode(current);
        }
    }, [ref]);
    const { children, strict, getOverflowContainer = defaultGetOverflowContainer, onHiddenBeforeChange = noop, title = renderTitle, ...rest } = props;
    const isOverFlow = useCallback(() => {
        const element = getOverflowContainer();
        if (element) {
            return utilIsOverflow(element);
        }
        return false;
    }, [getOverflowContainer]);
    const handleHiddenBeforeChange = useCallback((hidden) => {
        if (onHiddenBeforeChange(hidden) === false) {
            return false;
        }
        if (hidden) {
            return true;
        }
        return isOverFlow();
    }, [isOverFlow, onHiddenBeforeChange]);
    return (React.createElement(Tooltip, Object.assign({}, rest, { title: title, onHiddenBeforeChange: strict ? onHiddenBeforeChange : handleHiddenBeforeChange, ref: ref }), children));
};
OverflowTip.displayName = 'OverflowTip';
export default OverflowTip;
